import ReportingFilter from "components/reportingFilter/ReportingFilter";
import ReportingExport from "components/reportingExport/ReportingExport";
import { usePerformanceFilter } from "features/Library/Common/Hooks/usePerformanceFilter";

import "features/Library/Common/utils/performanceSCSSUtils.scss";
import { type RootState } from "features/Application/globaltypes/redux";
import { useAccountFilterShouldShow } from "features/Reporting/Content/queries/useAccountFilterShouldShow";
import { connect, type ConnectedProps } from "react-redux";
import cn from "classnames";
import styles from "./LinksPerformance.module.scss";
import { FeatureFlags } from "featureFlags";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";
import LinksReportBody from "features/Library/ExternalLinks/Performance/LinksReportBody";

type Props = {
  linkId: number;
  linkName: string;
} & PropsFromRedux;

const LinksPerformance = ({ linkId, linkName, accountId, accountType }: Props) => {
  const isReportEnabled = useFeatureFlag(FeatureFlags.LinkReport);
  const accountFilterShouldShow = useAccountFilterShouldShow(accountId, accountType, true);

  const [filter, setFilter] = usePerformanceFilter({
    accountId,
    includeDistinct: true,
    includeAccountsDropdown: accountFilterShouldShow,
    supportsSPType: true,
  });

  if (!isReportEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="performanceRoot">
      <div className="performanceHeader">
        <div className={cn("performanceHeader", styles.header)}>
          <h2 className="performanceTitle">Summary</h2>
          <div className="performanceActions">
            {/* @ts-ignore */}
            <ReportingFilter
              currentFilter={filter}
              callback={setFilter}
              includeAccountsDropdown={accountFilterShouldShow}
              includeDistinct
              ignoreInCountAndHide={["type"]}
              supportsSPType
            />
            <ReportingExport />
          </div>
        </div>
      </div>
      <LinksReportBody filter={filter} linkName={linkName} linkId={linkId} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountId: state.userProfile.accountId,
  accountType: state.userProfile.accountTypeId,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(LinksPerformance);
export default ConnectedComponent;
